<template>
	<v-form ref="unitary_form">
		<div
			v-for="group in groups_order"
			:key="group"
			:class="{collapsed: !groups_collapse[group]}"
			class="group group-named"
			:style="`border: 0.5px solid ${stringToColour(group)}`">
			<span
				v-if="group !== 'default'"
				title="Plier / déplier (CTRL pour Tous)"
				class="group-title title text-capitalize"
				@click="onGroupClick($event, group)"
				:style="`outline: 0.5px solid ${stringToColour(group)};
								color: ${stringToColour(group)}`">
				{{ group | spacedTitleCase }}
			</span>
			<v-fade-transition>
				<div v-show="!groups_collapse[group]" class="caption"
					:style="`color: ${stringToColour(group)}; margin-top: -34px; text-align: center;`">
					({{ groups[group].length }} paramètres)
				</div>
			</v-fade-transition>
			<v-slide-y-transition>
				<div v-show="groups_collapse[group]">
					<div v-for="(param, i) in groups[group]" :key="'param_' + i">
						<component
							:is="getFieldComponent(param)"
							:dense="dense"
							:param="param"
							:form="form"
							class="mt-3"
							:value.sync="form.parameters[param.name]"
							:readonly="readonly"
							:title="form.parameters[param.name]"
							@update-other-parameter="form.parameters[$event.name] = $event.value">
						</component>
					</div>
				</div>
			</v-slide-y-transition>
		</div>
	</v-form>
</template>

<script>
import CharField from '@/components/fields/char.vue'
import TextField from '@/components/fields/text.vue'
import BooleanField from '@/components/fields/boolean.vue'
import IntegerField from '@/components/fields/integer.vue'
import MultiIntegerField from '@/components/fields/multi_integer.vue'
import FloatField from '@/components/fields/float.vue'
import UrlField from '@/components/fields/url.vue'
import AssetidField from '@/components/fields/assetid.vue'
import JsonField from '@/components/fields/json.vue'
import SelectField from '@/components/fields/select.vue'
import OperatingZoneField from '@/components/fields/operatingzone.vue'
import FilesystemField from '@/components/fields/filesystem_path_file_folder.vue'
import TimecodeField from '@/components/fields/timecode.vue'
import BundleIdField from '@/components/fields/bundleid.vue'
import BabelIdField from '@/components/fields/babelid.vue'
import OwnerIdField from '@/components/fields/ownerid.vue'
import PatronIdField from '@/components/fields/patronid.vue'
import DateField from '@/components/fields/date.vue'
import DateTimeField from '@/components/fields/datetime.vue'
import EmailField from '@/components/fields/email.vue'
import ConfplatformIdField from '@/components/fields/confplatformid.vue'
import MissingField from '@/components/fields/missing.vue'
import TmdbIdField from '@/components/fields/tmdb_id.vue'

export default {
	props: [ 'dense', 'form', 'groups', 'groups_order', 'groups_collapse' ],
	components: {
		CharField,
		TextField,
		BooleanField,
		IntegerField,
		MultiIntegerField,
		FloatField,
		UrlField,
		AssetidField,
		JsonField,
		SelectField,
		OperatingZoneField,
		FilesystemField,
		TimecodeField,
		BundleIdField,
		BabelIdField,
		OwnerIdField,
		PatronIdField,
		DateField,
		DateTimeField,
		EmailField,
		ConfplatformIdField,
		MissingField,
		TmdbIdField
	},
	data () {
		return {
			readonly: false
		}
	},
	methods: {
		stringToColour (str) {
			return this.$colors.stringToHsl(str, 70)
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		},
		reset () {
			return this.$refs.unitary_form.reset()
		},
		onGroupClick (evt, group) {
			if (evt.ctrlKey) {
				let openOrClosed = !this.groups_collapse[group]
				for (const key in this.groups_collapse) {
					this.groups_collapse[key] = openOrClosed
				}
			} else {
				this.groups_collapse[group] = !this.groups_collapse[group]
			}
		},
		getFieldComponent (param) {
			if (param.type.indexOf('char') === 0) {
				return CharField
			} else if (param.type.indexOf('multi-char') === 0) {
				return CharField
			} else if (param.type.indexOf('text') === 0) {
				return TextField
			} else if (param.type.indexOf('assetid') === 0) {
				return AssetidField
			} else if (param.type.indexOf('multi-assetid') === 0) {
				return AssetidField
			} else if (param.type.indexOf('url') === 0) {
				return UrlField
			} else if (param.type.indexOf('multi-url') === 0) {
				return UrlField
			} else if (param.type.indexOf('integer') === 0) {
				return IntegerField
			} else if (param.type.indexOf('float') === 0) {
				return FloatField
			} else if (param.type.indexOf('multi-integer') === 0) {
				return MultiIntegerField
			} else if (param.type.indexOf('boolean') === 0) {
				return BooleanField
			} else if (param.type.indexOf('json') === 0) {
				return JsonField
			} else if (param.type.indexOf('select') === 0) {
				return SelectField
			} else if (param.type.indexOf('multi-select') === 0) {
				return SelectField
			} else if (param.type.indexOf('operatingzone') === 0) {
				return OperatingZoneField
			} else if (param.type.indexOf('file') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('directory') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('path') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('multi-file') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('multi-directory') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('multi-path') === 0) {
				return FilesystemField
			} else if (param.type.indexOf('timecode') === 0) {
				return TimecodeField
			} else if (param.type.indexOf('bundleid') === 0) {
				return BundleIdField
			} else if (param.type.indexOf('multi-bundleid') === 0) {
				return BundleIdField
			} else if (param.type.indexOf('babelid') === 0) {
				return BabelIdField
			} else if (param.type.indexOf('multi-babelid') === 0) {
				return BabelIdField
			} else if (param.type.indexOf('ownerid') === 0) {
				return OwnerIdField
			} else if (param.type.indexOf('multi-ownerid') === 0) {
				return OwnerIdField
			} else if (param.type.indexOf('patronid') === 0) {
				return PatronIdField
			} else if (param.type.indexOf('datetime') === 0) {
				return DateTimeField
			} else if (param.type.indexOf('date') === 0) {
				return DateField
			} else if (param.type.indexOf('email') === 0) {
				return EmailField
			} else if (param.type.indexOf('multi-email') === 0) {
				return EmailField
			} else if (param.type.indexOf('confplateformid') === 0) {
				return ConfplatformIdField
			} else if (param.type.indexOf('ofid') === 0) {
				return IntegerField
			} else if (param.type.indexOf('tmdbid') === 0) {
				return TmdbIdField
			} else {
				return MissingField
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.group-named
		border-radius: 2px
		margin-bottom: 24px
		// border: 0.5px solid var(--v-background-lighten2)
		padding: 16px 12px 4px 12px
		margin-top: 12px
		margin-bottom: 32px
	.group-title
		cursor: pointer
		padding: 4px 8px
		// outline: 0.5px solid var(--v-background-lighten2)
		border-radius: 2px
		background-color: var(--v-background-darken1)
		left: -24px
		top: -26px
		position: relative
		// color: var(--v-color-lighten5)
	.group-title:hover
		outline: 0.5px solid var(--v-primary-base) !important
		color: var(--v-primary-base) !important

.group-named.collapsed
	border-bottom: none
	border-left: none
	border-right: none
	margin-bottom: 28px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form.vue